import { pertoTaskSchema, type CreatePertoTask, type PertoTask } from '@secretario/shared';
import { z } from 'zod';
import { apiFetch } from './http.js';

/** O pedido do Perto de Mim (PA2): o Secretário pede a até 3 negócios e acompanha. */
export const PERTO_TASKS_KEY = ['perto-tasks'] as const;
export const pertoTaskKey = (id: string) => ['perto-tasks', id] as const;

const list = z.object({ tasks: z.array(pertoTaskSchema) });

export async function listPertoTasks(): Promise<PertoTask[]> {
  return list.parse(await apiFetch<unknown>('/v1/perto/tasks')).tasks;
}
export async function getPertoTask(id: string): Promise<PertoTask> {
  return pertoTaskSchema.parse(await apiFetch<unknown>(`/v1/perto/tasks/${id}`));
}
export async function createPertoTask(input: CreatePertoTask): Promise<PertoTask> {
  return pertoTaskSchema.parse(
    await apiFetch<unknown>('/v1/perto/tasks', { method: 'POST', body: input }),
  );
}
export async function pertoTaskSent(id: string, placeId: string): Promise<PertoTask> {
  return pertoTaskSchema.parse(
    await apiFetch<unknown>(`/v1/perto/tasks/${id}/sent`, { method: 'POST', body: { placeId } }),
  );
}
export async function pertoTaskReply(
  id: string,
  placeId: string,
  text: string,
  at?: number,
): Promise<PertoTask> {
  return pertoTaskSchema.parse(
    await apiFetch<unknown>(`/v1/perto/tasks/${id}/reply`, {
      method: 'POST',
      body: { placeId, text, ...(at ? { at: new Date(at).toISOString() } : {}) },
    }),
  );
}
export async function pertoTaskChoose(
  id: string,
  placeId: string,
  when: string | null,
): Promise<PertoTask> {
  return pertoTaskSchema.parse(
    await apiFetch<unknown>(`/v1/perto/tasks/${id}/choose`, {
      method: 'POST',
      body: { placeId, when },
    }),
  );
}
export async function pertoTaskClose(id: string): Promise<PertoTask> {
  return pertoTaskSchema.parse(
    await apiFetch<unknown>(`/v1/perto/tasks/${id}/close`, { method: 'POST', body: {} }),
  );
}
